import { useState } from "react"

const DEFAULT_DATA = {
  player: null,
  chat: false,
  author: null,
  title: null,
}

export function useData(queryString, setQueryString) {
  const initialData = queryString.video
    ? queryString.video.map(({ id: videoId, ...data }) => ({
        uuid: crypto.randomUUID(),
        videoId,
        ...DEFAULT_DATA,
        ...data,
      }))
    : []

  const initialPositions = {
    1: initialData.find((d) => d.position === 1)?.uuid,
    2: initialData.find((d) => d.position === 2)?.uuid,
    3: initialData.find((d) => d.position === 3)?.uuid,
    4: initialData.find((d) => d.position === 4)?.uuid,
    5: initialData.find((d) => d.position === 5)?.uuid,
    6: initialData.find((d) => d.position === 6)?.uuid,
    7: initialData.find((d) => d.position === 7)?.uuid,
    8: initialData.find((d) => d.position === 8)?.uuid,
    9: initialData.find((d) => d.position === 9)?.uuid,
  }

  const [positions, setPositions] = useState(initialPositions)

  const [data, setData] = useState(initialData)

  const addVideo = (position, videoId, data = {}) => {
    const uuid = crypto.randomUUID()

    setData((prevData) => [
      ...prevData,
      {
        uuid,
        videoId,
        player: null,
        chat: false,
        ...data,
      },
    ])

    setPositions((prevPositions) => ({
      ...prevPositions,
      [position]: uuid,
    }))

    const newVideo = {
      id: videoId,
      position,
    }

    if (data.chat) {
      newVideo.chat = true
    }

    setQueryString({
      ...queryString,
      video: [...(queryString?.video || []), newVideo],
    })
  }

  const updateVideo = (position, uuid, newData) => {
    setData((prevData) => prevData.map((d) => (d.uuid === uuid ? { ...d, ...newData } : d)))

    if (newData?.videoId) {
      const video = queryString.video
      const itemIndex = video.findIndex((v) => v.position === position)
      const item = video[itemIndex]
      video[itemIndex] = {
        ...item,
        id: newData.videoId,
      }

      setQueryString({
        ...queryString,
        video,
      })
    }
  }

  const removeAll = () => {
    setData([])
    setPositions({
      1: undefined,
      2: undefined,
      3: undefined,
      4: undefined,
      5: undefined,
      6: undefined,
      7: undefined,
      8: undefined,
      9: undefined,
    })
    const { video, ...rest } = queryString
    setQueryString(rest)
  }

  const removeVideo = (position, uuid) => {
    setData((prevData) => prevData.filter((videoData) => videoData.uuid !== uuid))

    setPositions((prevPositions) => ({
      ...prevPositions,
      [position]: null,
    }))

    setQueryString({
      ...queryString,
      video: queryString.video.filter((d) => d.position !== position),
    })
  }

  const pauseAll = () => {
    data.map((d) => d.player?.pauseVideo())
  }

  const playAll = () => {
    data.map((d) => d.player?.playVideo())
  }

  const playPause = (uuid) => {
    const video = data.find((d) => d.uuid === uuid)
    if (!video) return

    video.player?.getPlayerState() == 1 ? video.player?.pauseVideo() : video.player?.playVideo()
  }

  const muteAll = () => {
    data.map((d) => d.player?.mute())
  }

  const unMuteAll = () => {
    data.map((d) => d.player?.unMute())
  }

  const muteUnMute = (uuid) => {
    const video = data.find((d) => d.uuid === uuid)
    if (!video) return

    video.player?.isMuted() ? video.player?.unMute() : video.player?.mute()
  }

  const muteAllBut = (uuid) => {
    data.map((d) => {
      d.uuid === uuid ? d.player?.unMute() : d.player?.mute()
    })
  }

  const swapPositions = (source, destination) => {
    setPositions((prevPositions) => ({
      ...prevPositions,
      [source]: prevPositions[destination],
      [destination]: prevPositions[source],
    }))

    const video = queryString.video
    const sourceItemIndex = video.findIndex((v) => v.position === source)
    const destinationItemIndex = video.findIndex((v) => v.position === destination)

    if (sourceItemIndex >= 0) {
      const sourceItem = video[sourceItemIndex]
      video[sourceItemIndex] = {
        ...sourceItem,
        position: destination,
      }
    }

    if (destinationItemIndex >= 0) {
      const destinationItem = video[destinationItemIndex]
      video[destinationItemIndex] = {
        ...destinationItem,
        position: source,
      }
    }

    setQueryString({
      ...queryString,
      video,
    })
  }

  const firstAvailablePosition = () => {
    const position = Object.entries(positions).find(
      ([_key, val]) => val === undefined || val === null
    )

    if (position) {
      return parseInt(position[0])
    } else {
      return -1
    }
  }

  return {
    data,
    positions,
    addVideo,
    updateVideo,
    removeAll,
    removeVideo,
    pauseAll,
    playAll,
    playPause,
    muteAll,
    unMuteAll,
    muteUnMute,
    muteAllBut,
    swapPositions,
    firstAvailablePosition,
  }
}
